import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

import numberFormatter from '../../numberFormatter';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

interface VerticalBarChartProps {
  title: string;
  labels: string[];
  data: number[];
  datasetLabel: string;
  backgroundColor: string;
  borderColor: string;
  data2?: number[];
  datasetLabel2?: string;
  backgroundColor2?: string;
  borderColor2?: string;
  data3?: number[];
  datasetLabel3?: string;
  backgroundColor3?: string;
  borderColor3?: string;
  data4?: number[];
  datasetLabel4?: string;
  backgroundColor4?: string;
  borderColor4?: string;
  stackId1?: string;
  stackId2?: string;
  stackId3?: string;
  stackId4?: string;
  stacked?: boolean;
  key: string;
}

export const VerticalBarChart: React.FC<VerticalBarChartProps> = props => {
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const,
        labels: {
          boxWidth: 10,
          font: {
            family: 'Inter, sans-serif',
            size: 12,
          },
          padding: 15,
        },
      },
      title: {
        display: true,
        text: props.title,
        font: {
          family: 'Inter, sans-serif',
          size: 18,
        },
        padding: {
          bottom: 20,
        },
      },
    },
    scales: {
      x: {
        stacked: props.stacked,
        ticks: {
          font: {
            family: 'Inter, sans-serif',
            size: 12,
          },
          color: '#333',
        },
        grid: {
          color: '#f0f0f0',
        },
      },
      y: {
        stacked: props.stacked,
        ticks: {
          font: {
            family: 'Inter, sans-serif',
            size: 12,
          },
          color: '#333',
          callback: function (value: number | string) {
            return numberFormatter(value);
          },
        },
        grid: {
          color: '#f0f0f0',
        },
      },
    },
    elements: {
      bar: {
        borderRadius: 12,
        borderWidth: 2,
      },
    },
  };

  const data = {
    labels: props.labels,
    datasets: [
      {
        label: props.datasetLabel,
        data: props.data,
        backgroundColor: props.backgroundColor,
        borderColor: props.borderColor,
        borderWidth: 2,
        ...(props.stackId1 ? { stack: props.stackId1 } : {}),
      },
      ...(props.data2
        ? [
            {
              label: props.datasetLabel2,
              data: props.data2,
              backgroundColor: props.backgroundColor2,
              borderColor: props.borderColor2,
              borderWidth: 2,
              ...(props.stackId2 ? { stack: props.stackId2 } : {}),
            },
          ]
        : []),
      ...(props.datasetLabel3
        ? [
            {
              label: props.datasetLabel3,
              data: props.data3,
              backgroundColor: props.backgroundColor3,
              borderColor: props.borderColor3,
              borderWidth: 2,
              ...(props.stackId3 ? { stack: props.stackId3 } : {}),
            },
          ]
        : []),
      ...(props.datasetLabel4
        ? [
            {
              label: props.datasetLabel4,
              data: props.data4,
              backgroundColor: props.backgroundColor4,
              borderColor: props.borderColor4,
              borderWidth: 2,
              ...(props.stackId4 ? { stack: props.stackId4 } : {}),
            },
          ]
        : []),
    ],
  };

  return (
    <div className="chart-container">
      <div className="chart-wrapper">
        <Bar key={props.key} options={options} data={data} />
      </div>
    </div>
  );
};
